import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { message } from "antd";
import axiosHttp from "services/axiosHttp";

export const uploadAssetBulk = createAsyncThunk(
     "uploadAssetBulk",
     async ({ file }, { rejectWithValue }) => {
          try {
               const token = localStorage.getItem("auth_token");
               const config = {
                    headers: {
                         Authorization: `Bearer ${token}`,
                         "Access-Control-Allow-Origin": "*",
                         "Content-Type": "multipart/form-data",
                         Accept: "application/json",
                    },
               };
               const formData = new FormData();
               formData.append("file", file);
               const response = await axiosHttp.post(`assets/bulk/upload`, formData, config);
               message.success("Asset list has been uploaded successfully!");
               return response.data;
          } catch (err) {
               if (!err.response) {
                    throw err;
               }
               return rejectWithValue(err.response.data);
          }
     }
);

const AssetBulkUploadSlice = createSlice({
     name: "AssetBulkUploadSlice",
     initialState: {
          isLoading: false,
          isError: false,
          error: null,
          data: null,
     },

     reducers: {
          resetBulkUploadState: (state) => {
               state.isLoading = false;
               state.isError = false;
               state.error = null;
               state.data = null;
          },
     },

     extraReducers: (builder) => {
          builder.addCase(uploadAssetBulk.pending, (state) => {
               state.isLoading = true;
               state.isError = false;
          });

          builder.addCase(uploadAssetBulk.fulfilled, (state, action) => {
               state.isLoading = false;
               state.isError = false;
               // backend shape: { code, message, data: { success_row_count, error_row_count, error: [] } }
               state.data = action.payload?.data ?? action.payload;
          });

          builder.addCase(uploadAssetBulk.rejected, (state, action) => {
               state.isLoading = false;
               state.isError = true;
               // on 400 the backend sends the same shape with counts + error rows
               state.error = action.payload?.data ?? action.payload;
               state.data = null;
          });
     },
});

export const { resetBulkUploadState } = AssetBulkUploadSlice.actions;
export default AssetBulkUploadSlice.reducer;